/** @jsx jsx */
import { css, jsx, styled } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/stakeholders-skeleton.tpl.svg';

const customCssStyles = css({
	// increase self specificity to ensure deterministic override
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		borderRightWidth: 0,
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, jira/styled/styled-component-order
const Wrapper = styled.div({
	display: 'contents',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'>div > img, > div > object': {
		borderLeftWidth: '24px',
		borderRightWidth: '24px',
	},
});

export const StakeholdersSkeleton = (): JSX.Element => (
	<Wrapper>
		<AppSkeletonImage src={imgSVG} css={customCssStyles} />
	</Wrapper>
);
